import { useState } from "react";
import { WebSocketContext } from "./WebSocket.context.tsx";
import type WebSocketProperties from "./WebSocket.properties.ts";

export const WebSocketProvider = (props: WebSocketProperties) => {
  const [isWebSocketConnected, setIsWebSocketConnected] = useState<
    boolean | null
  >(null);

  return (
    <WebSocketContext.Provider
      value={{ isWebSocketConnected, setIsWebSocketConnected }}
    >
      {props.children}
    </WebSocketContext.Provider>
  );
};
